import axios from "axios";
import { jwtDecode } from "jwt-decode";

let baseURL = process.env.REACT_APP_BASE_URL;

const LOG_EXPORTS_URL = `${baseURL}sp/v2/logexports`;

/**
 * Extract userId from JWT token
 * @returns {string|null} userId or null if token not found
 */
const getUserIdFromToken = () => {
  try {
    const token = localStorage.getItem("appToken");
    if (!token) return null;
    
    const decoded = jwtDecode(token);
    // Extract userId from the nameidentifier claim
    const userId = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
    return userId || null;
  } catch (error) {
    console.error("Error extracting userId from token:", error);
    return null;
  }
};

/**
 * Log CSV export to the server
 * @param {string} pageName - Name of the page where export was triggered
 */
export const logExport = async (pageName) => {
  try {
    const userId = getUserIdFromToken();
    const token = localStorage.getItem("appToken");
    
    if (!userId || !token) {
      console.warn("Export log skipped: Missing userId or token");
      return;
    }

    const payload = {
      userId: userId,
      pageName: pageName
    };

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };

    await axios.post(LOG_EXPORTS_URL, payload, { headers });
    console.log(`Export logged for page: ${pageName}`);
  } catch (error) {
    console.error("Error logging export:", error);
    // Don't throw error - export should still succeed even if logging fails
  }
};

export const exportLogService = {
  logExport,
  getUserIdFromToken
};
